<template>
	<el-drawer dirction='rtl' :visible.sync="visibleTree" size="40%" >
		<div style="margin:0 20px">
			<el-input placeholder="输入关键字过滤" prefix-icon="el-icon-search" v-model="filterText1"
				style="width: 100%;margin-top:70px;" clearable></el-input>

			<el-tree style="width:100%;margin-top:20px" :data="allTree" :props="props" @node-click="handleNodeClickTree"
				@check-change="currentChange" node-key="id" :show-checkbox="is_check" :filter-node-method="filterNode1"
				:check-on-click-node="is_check?false:true" class="objectTree" ref="treeSelect">

				<span slot-scope="{node,data}" class="custom-tree-node">
					<span style="font-size:16px;" :style="is_allow&&!data.allow?'color:#cccccc':''">
						<svg data-v-7eb2bc79 :aria-hidden=true class="icon" v-if="node.childNodes.length!=0">
							<use data-v-7eb2bc79 :xlink:href="node.expanded?'#icon-wenjianjia3':'#icon-wenjianjia2'">
							</use>
						</svg>
						<svg data-v-7eb2bc79 :aria-hidden=true class="icon" v-else>
							<use data-v-7eb2bc79 :xlink:href="node.expanded?'#icon-wenjianjia1':'#icon-iconset0196'">
							</use>
						</svg>
						<span :class="data.checked?'checked-select':''">{{data.id==null?'全部目录' : node.label }}</span>
					</span>
				</span>
			</el-tree>
			<div class="demo-drawer-footer1" style="width:40%">
				<el-button style="margin-right:30px" @click.stop="closeTree()">取 消</el-button>
				<el-button type="primary" @click.stop="getCurrentData()">确 定</el-button>
			</div>
		</div>
	</el-drawer>
</template>

<script>
	import { Drawer } from 'iview';
	import { oa_catalog } from "@/api/server";
	import { record_catalog, record_tag } from "@/api/record";
	export default {
		props: {
			is_allow: {
				type: Boolean,
				default: false,
			},
			type: {
				type: String,
				default: 'mission',//mission 任务资料目录，record 实录目录，record_tag 实录标签
			},
			is_leaf: {
				type: Boolean,
				default: false
			},
			is_check: {  //单选还是多选
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				allTree: [],
				filterText1: '',
				visibleTree: false,
				props: { label: "name", children: 'children' },
				current_data: null,
			}
		},

		components: {
			Drawer,
		},

		watch: {
			filterText1(val) {
				this.$refs.treeSelect.filter(val);
			},
		},

		methods: {
			currentChange(data, value) {
				if (!data.id) {
					this.allTree.forEach(v => {
						if (v.id) {
							this.$refs.treeSelect.setChecked(v.id, value, true)
						}
					})
				}
			},
			closeTree() {
				console.log('======>')
				this.visibleTree = false;
				this.$emit('close');
			},
			filterNode1(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			getCurrentData() {
				if (this.is_check) {
					let items = this.$refs.treeSelect.getCheckedNodes()
					items = items.filter(e => e.id)
					if (items && items.length > 0) {
						this.$emit('getCheckList', items);
					}
				} else {
					if (!this.current_data || this.current_data.id == null || this.current_data.id == '0') {
						this.current_data = { id: null, name: '全部归档目录' }
					}
					this.$emit('getCurrentCatalog', this.current_data);
				}
				this.visibleTree = false;
			},
			handleNodeClickTree(data, Node) {
				if (this.is_check) {
					return
				}
				if (this.is_allow && !data.allow) {
					this.$message({ message: "暂无权限!", type: "error" });
					return
				}
				this.current_data = { id: data.id, name: '' };
				// 去掉勾选
				this.allTree.forEach(v => {
					this.find(v);
				})

				// 找目录并勾选
				this.findParent(Node);
				data.checked = !this.is_leaf ? true : (!data.children ? true : false);
			},
			findParent(node) {
				if (node.parent) {
					this.current_data.name = node.data.name + ' / ' + this.current_data.name;
					this.findParent(node.parent);
				}
			},
			find: function (data) {
				data.checked = false;
				if (this.is_check) {
					data.disable = this.is_allow && !data.allow ? true : false
				}
				if (data.children) {
					data.children.forEach(e => {
						this.find(e);
					})
				}
			},

			getAllTree() {
				let promise = this.type == 'mission' ? oa_catalog.getCatalogTree({ role_ids: null }) : this.type == 'record' ? record_catalog.getNodeList() : record_tag.getNodeList();
				promise.then(res => {
					if (res.data) {
						res.data.forEach(v => {
							if (this.is_check) {
								v.disable = this.is_allow && !v.allow ? true : false
							}
							this.find(v);
						})
						this.allTree = res.data;

						this.allTree.forEach(r => r.checked = false)

						if (this.type == 'mission') {
							let ret = this.allTree.find(r => !r.stashes && r.id != null);
							if (ret != null) {
								return ret
							}
						}
					} else {
						this.allTree = [];
						return null
					}
				});
			},

			openAllTree() {
				this.visibleTree = true;
				this.current_data = null;
				this.filterText1=''
				if (this.allTree == '') {
					this.getAllTree();
				} else {
					this.allTree.forEach(v => {
						this.$refs.treeSelect.setChecked(v, false, true)
					})
				}
			}
		},

		mounted() {

		}

	}
</script>

<style scoped>
	.checked-select {
		color: #17ad9f;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/selectCatalog.vue